<template>
  <div class="resume">
    <div class="resume-header">
      <h2 class="title">resume.</h2>
      <a :href="`${path}/files/CindyCheaResume.pdf`" download>Download Full Resume</a>
    </div>
    <div class="resume-content">
      <div class="left">
        <div class="education wow fadeInLeft animated">
          <h5>EDUCATION</h5>
          <p><b>Web Development Immersive</b></p>
          <p><b>Full Stack Web Development</b></p>
          <p>General Assembly Toronto</p>
          <p><i>April – July 2019</i></p>
          <p class="soft"><b>Bachelor of Science in Nursing</b></p>
          <p><b>Bachelor of Science (Molecular Biology and Genetics)</b></p>
          <p>McMaster University</p>
          <p><i>2012 – 2016</i></p>
        </div>
        <div class="personal-skills wow fadeInLeft animated">
          <h5>SKILLS</h5>
          <p>Communication</p>
          <p>Critical Thinking</p>
          <p>Problem Solving</p>
          <p>Adaptability</p>
          <p>Collaboration/Teamwork</p>
          <p>Leadership</p>
          <p>Advocacy</p>
        </div>
      </div>
      <div class="right">
        <div class="skills wow fadeInRight animated">
          <h5>TECHNICAL SKILLS</h5>
          <ul class="tech">
            <li>
              <img src="@/assets/html.svg" alt="HTML" />
              <p>HTML</p>
            </li>
            <li>
              <img src="@/assets/css.svg" alt="CSS" />
              <p>CSS</p>
            </li>
            <li>
              <img src="@/assets/javascript.svg" alt="Javascript" />
              <p>Javascript</p>
            </li>
            <li>
              <img src="@/assets/python.svg" alt="Python" />
              <p>Python</p>
            </li>
            <li>
              <img src="@/assets/django.svg" alt="Django" />
              <p>Django</p>
            </li>
            <li>
              <img src="@/assets/postgresql.svg" alt="PostgreSQL" />
              <p>PostgreSQL</p>
            </li>
            <li>
              <img src="@/assets/api.svg" alt="API" />
              <p>RESTful API</p>
            </li>
            <li>
              <img src="@/assets/react.svg" alt="React" />
              <p>React</p>
            </li>
            <li>
              <img src="@/assets/git.svg" alt="Git" />
              <p>Git</p>
            </li>
            <li>
              <img src="@/assets/vscode.svg" alt="VS Code" />
              <p>VS Code</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'resume',
  components: {
    HelloWorld
  },
  data() {
    return {
      path: window.location.origin,
    }
  }
}
</script>

<style lang="scss" scoped>
.resume {
  min-height: 100vh;
  width: 100%;
  .resume-header {
    display: flex;
    flex-direction: row;
    margin: 0;
    padding: 0 20px 0 0;
    h2 {
      margin: 0;
    }
    a {
      align-self: flex-end;
      text-decoration: none;
      color: #e93646;
      background-color: #242B38;
      font-weight: bold;
      border-radius: 5px;
      width: auto;
      margin-left: auto;
      padding: 0.7em;
    }
    a:hover {
      color: #FFC7C4;
    }
  }
  .resume-content {
    font-family: 'Raleway', sans-serif;
    display: grid;
    grid-template-columns: 1fr 2fr;
    grid-template-rows: 1fr;
    padding: 2em 0 4em;
    .left {
      grid-column: 1;
      border-right: 1px solid #505050;
      padding: 0 40px;
      .education {
        p {
          margin: 0;
          text-align: right;
        }
        .soft {
          padding-top: 20px;
        }
      }
      .personal-skills {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        h5 {
          align-self: center;
          padding-top: 30px;
        }
        p {
          margin: 0;
        }
      }
    }
    .right {
      padding: 0 60px 0 40px;
      grid-column: 2;
      .skills {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        h5 {
          align-self: center;
        }
        .tech {
          list-style-type: none;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: center;
          li {
            padding: 20px;
            opacity: 1;
            filter: alpha(opacity=100);
            img {
              width: 80px;
            }
            p {
              font-weight: bold;
            }
          }
          li:hover {
            opacity: 0.5;
            filter: alpha(opacity=30);
          }
        }
      }
    }
  }

}
</style>